(function () {
  const mobileQuery = window.matchMedia('(max-width:749px)');

  function setupProduct(product) {
    const mediaList = product.querySelector('.product__media-list');
    const mediaItems = mediaList ? Array.from(mediaList.querySelectorAll('.product__media-item')) : [];
    const thumbs = Array.from(product.querySelectorAll('.thumbnail-list .thumbnail'));

    if (!mediaItems.length || !thumbs.length) return;

    const byId = new Map();
    mediaItems.forEach((mediaItem) => {
      const id = mediaItem.id || mediaItem.dataset.mediaId;
      if (id) byId.set(id, mediaItem);
      mediaItem.classList.remove('__mobile-visible');
    });

    if (mobileQuery.matches) mediaItems[0].classList.add('__mobile-visible');

    const setActiveThumb = (thumb) => {
      thumbs.forEach((item) => item.classList.remove('is-active'));
      if (thumb) thumb.classList.add('is-active');
    };

    setActiveThumb(thumbs[0]);

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener(
        'click',
        (event) => {
          if (!mobileQuery.matches) return;
          event.preventDefault();
          event.stopPropagation();

          const key =
            thumb.getAttribute('aria-controls') ||
            (thumb.dataset.target || '').replace('#', '') ||
            thumb.getAttribute('data-media-id') ||
            ((thumb.getAttribute('href') || '').split('#')[1]);

          const target =
            (key && (byId.get(key) || product.querySelector(`#${key}`))) ||
            mediaItems[index] ||
            mediaItems[0];

          if (!target) return;

          mediaItems.forEach((mediaItem) => mediaItem.classList.remove('__mobile-visible'));
          target.classList.add('__mobile-visible');
          setActiveThumb(thumb);
        },
        { passive: false }
      );
    });
  }

  function initAll() {
    if (!mobileQuery.matches) return;
    document.querySelectorAll('product-info .product').forEach(setupProduct);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('resize', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('variant:changed', initAll);
})();
